// src/consts/activationStatus.ts
var ACTIVATION_STATUS_TYPES = {
  ACTIVE: "active",
  INACTIVE: "inactive"
};

// src/consts/chat.const.ts
var CHAT_BOT_ROLES = {
  SYSTEM: "system",
  USER: "user",
  ASSISTANT: "assistant"
};

// src/consts/lesson.const.ts
var LESSON_TYPES = {
  VIDEO: "VIDEO",
  TEXT: "TEXT",
  QUIZ: "QUIZ"
};
var LESSON_TITLE_MAX_LENGTH = 500;
var NON_TEXT_LESSON_DESCRIPTION_MAX_LENGTH = 1e3;
var TEXT_LESSON_DESCRIPTION_MAX_LENGTH = 3e3;

// src/consts/content.const.ts
var CONTENT_TYPES = {
  EMPTY: "EMPTY",
  CHAPTER_FORM: "CHAPTER_FORM",
  SELECT_LESSON_TYPE: "SELECT_LESSON_TYPE",
  TEXT_LESSON_FORM: "TEXT_LESSON_FORM",
  VIDEO_LESSON_FORM: "VIDEO_LESSON_FORM",
  QUIZ_FORM: "QUIZ_FORM"
};
var DELETE_CONTENT_TYPES = {
  ...LESSON_TYPES,
  COURSE: "COURSE",
  CHAPTER: "CHAPTER",
  QUESTION: "QUESTION",
  FLASHCARD_CATEGORY: "FLASHCARD_CATEGORY"
};
var PUBLISH_CONTENT_TYPES = {
  COURSE: "COURSE",
  PUBLISH_FLASHCARD_CATEGORY: "PUBLISH_FLASHCARD_CATEGORY",
  UNPUBLISH_FLASHCARD_CATEGORY: "UNPUBLISH_FLASHCARD_CATEGORY"
};

// src/consts/defaultPageSize.ts
var DEFAULT_PAGE_SIZE = 20;

// src/consts/emailTemplates.const.ts
var EMAIL_TEMPLATES = {
  WELCOME: "welcome",
  PASSWORD_RECOVERY: "passwordRecovery",
  CREATE_PASSWORD_REMINDER: "createPasswordReminder",
  BOUGHT_SUBJECT: "boughtSubject",
  CREATE_PASSWORD_EMAIL_BY_ADMIN: "createPasswordEmailByAdmin",
  GUARDIAN_LINK: "guardianLink",
  GUARDIAN_REGISTER: "guardianRegister",
  FRIEND_INVITATION: "friendInvitation"
};

// src/consts/environment.const.ts
var ENVIRONMENT = {
  DEVELOPMENT: "development",
  PRODUCTION: "production",
  STAGING: "staging",
  TEST: "test",
  LOCAL: "local"
};

// src/consts/errorCodes.const.ts
var CustomErrorCode = {
  USER_EMAIL_EXISTS: "USER_EMAIL_EXISTS",
  COURSE_HAS_NO_LESSONS: "COURSE_HAS_NO_LESSONS",
  USER_STUDENT_PROGRESS_EXISTS: "USER_STUDENT_PROGRESS_EXISTS",
  USER_BANNED: "USER_BANNED"
};

// src/consts/eventLogs.conts.ts
var EVENT_TYPE = {
  USER_CREATED_BY_ADMIN: "USER_CREATED_BY_ADMIN",
  LESSON_CREATED: "LESSON_CREATED",
  ADDITIONAL_MATERIAL_ADDED: "ADDITIONAL_MATERIAL_ADDED",
  FLASHCARD_CREATED: "FLASHCARD_CREATED",
  SUBJECT_COMPLETED: "SUBJECT_COMPLETED",
  VIDEO_WATCHED: "VIDEO_WATCHED",
  LESSON_COMPLETED: "LESSON_COMPLETED",
  COURSE_COMPLETED: "COURSE_COMPLETED",
  FRIEND_INVITED: "FRIEND_INVITED",
  USER_LOGGED_IN: "USER_LOGGED_IN",
  ADDITIONAL_RESOURCE_DOWNLOADED: "ADDITIONAL_RESOURCE_DOWNLOADED"
};
var AGGREGATE_TYPE = {
  USER: "USER",
  LESSON: "LESSON",
  FLASHCARD: "FLASHCARD"
};

// src/consts/flashcard.const.ts
var FLASHCARD_CATEGORY_TITLE_MAX_LENGTH = 200;

// src/consts/friendInvitation.const.ts
var FRIENT_INVITATION_STATUS = {
  SENT: "SENT",
  ACCEPTED: "ACCEPTED",
  EXPIRED: "EXPIRED"
};

// src/consts/gamification/badgeType.const.ts
var BADGE_TYPE = {
  POWER_SIGN: "POWER_SIGN",
  LEARNING_TROPHY: "LEARNING_TROPHY",
  BIDIRECTIONAL_TROPHY: "BIDIRECTIONAL_TROPHY",
  INTERDISCIPLINARY_TROPHY: "INTERDISCIPLINARY_TROPHY"
};

// src/consts/gamification/trophyType.const.ts
var TROPHY_TYPE = {
  // POWER_SIGN
  STARTER: "STARTER",
  SOCIAL_MOTIVATOR: "SOCIAL_MOTIVATOR",
  MOTIVATION_AMBASSADOR: "MOTIVATION_AMBASSADOR",
  LESSON_SPRINTER: "LESSON_SPRINTER",
  DAILY_RECORD_HOLDER: "DAILY_RECORD_HOLDER",
  VIRTUAL_EXPLORER: "VIRTUAL_EXPLORER",
  PERSISTENT_WANDERER: "PERSISTENT_WANDERER",
  CONSTRUCTIVE_REVIEWER: "CONSTRUCTIVE_REVIEWER",
  // LEARNING_TROPHY
  MATH_MASTER: "MATH_MASTER",
  POLISH_MASTER: "POLISH_MASTER",
  ENGLISH_MASTER: "ENGLISH_MASTER",
  MATH_QUIZ_MARATHONER: "MATH_QUIZ_MARATHONER",
  POLISH_QUIZ_MARATHONER: "POLISH_QUIZ_MARATHONER",
  ENGLISH_QUIZ_MARATHONER: "ENGLISH_QUIZ_MARATHONER",
  MATH_PRECISE_MIND: "MATH_PRECISE_MIND",
  POLISH_PRECISE_MIND: "POLISH_PRECISE_MIND",
  ENGLISH_PRECISE_MIND: "ENGLISH_PRECISE_MIND",
  MATH_FLAWLESS_MIND: "MATH_FLAWLESS_MIND",
  POLISH_FLAWLESS_MIND: "POLISH_FLAWLESS_MIND",
  ENGLISH_FLAWLESS_MIND: "ENGLISH_FLAWLESS_MIND",
  MATH_VIDEO_ENTHUSIAST: "MATH_VIDEO_ENTHUSIAST",
  POLISH_VIDEO_ENTHUSIAST: "POLISH_VIDEO_ENTHUSIAST",
  ENGLISH_VIDEO_ENTHUSIAST: "ENGLISH_VIDEO_ENTHUSIAST",
  MATH_DIDACTIC_COLLECTOR: "MATH_DIDACTIC_COLLECTOR",
  POLISH_DIDACTIC_COLLECTOR: "POLISH_DIDACTIC_COLLECTOR",
  ENGLISH_DIDACTIC_COLLECTOR: "ENGLISH_DIDACTIC_COLLECTOR",
  // BIDIRECTIONAL_TROPHY
  TWO_SUBJECT_MASTER_MAT_ENG: "TWO_SUBJECT_MASTER_MAT_ENG",
  TWO_SUBJECT_MASTER_MAT_POL: "TWO_SUBJECT_MASTER_MAT_POL",
  TWO_SUBJECT_MASTER_ENG_POL: "TWO_SUBJECT_MASTER_ENG_POL",
  TWO_SECTION_EXPERT_MAT_ENG: "TWO_SECTION_EXPERT_MAT_ENG",
  TWO_SECTION_EXPERT_MAT_POL: "TWO_SECTION_EXPERT_MAT_POL",
  TWO_SECTION_EXPERT_ENG_POL: "TWO_SECTION_EXPERT_ENG_POL",
  QUIZ_DUO_MAT_ENG: "QUIZ_DUO_MAT_ENG",
  QUIZ_DUO_MAT_POL: "QUIZ_DUO_MAT_POL",
  QUIZ_DUO_ENG_POL: "QUIZ_DUO_ENG_POL",
  FLAWLESS_DUO_MAT_ENG: "FLAWLESS_DUO_MAT_ENG",
  FLAWLESS_DUO_MAT_POL: "FLAWLESS_DUO_MAT_POL",
  FLAWLESS_DUO_ENG_POL: "FLAWLESS_DUO_ENG_POL",
  VIDEO_DUO_MAT_ENG: "VIDEO_DUO_MAT_ENG",
  VIDEO_DUO_MAT_POL: "VIDEO_DUO_MAT_POL",
  VIDEO_DUO_ENG_POL: "VIDEO_DUO_ENG_POL",
  DIDACTIC_DUO_MAT_ENG: "DIDACTIC_DUO_MAT_ENG",
  DIDACTIC_DUO_MAT_POL: "DIDACTIC_DUO_MAT_POL",
  DIDACTIC_DUO_ENG_POL: "DIDACTIC_DUO_ENG_POL",
  // INTERDISCIPLINARY_TROPHY
  THREE_SUBJECT_MASTER: "THREE_SUBJECT_MASTER",
  THREE_SECTION_EXPERT: "THREE_SECTION_EXPERT",
  QUIZ_TRIATHLON: "QUIZ_TRIATHLON",
  FLAWLESS_TRIO: "FLAWLESS_TRIO",
  VIDEO_TRIAD: "VIDEO_TRIAD",
  DIDACTIC_TRIAD: "DIDACTIC_TRIAD"
};

// src/consts/gamification/trophyRequirements.cosnt.ts
var TROPHY_REQUIREMENTS = {
  // POWER_SIGN
  [TROPHY_TYPE.STARTER]: [1],
  [TROPHY_TYPE.SOCIAL_MOTIVATOR]: [2, 4, 6, 8],
  [TROPHY_TYPE.MOTIVATION_AMBASSADOR]: [1, 2, 3, 4],
  [TROPHY_TYPE.LESSON_SPRINTER]: [2, 4, 6, 8],
  [TROPHY_TYPE.DAILY_RECORD_HOLDER]: [2, 3, 5, 7],
  [TROPHY_TYPE.VIRTUAL_EXPLORER]: [1, 2, 3, 4],
  [TROPHY_TYPE.PERSISTENT_WANDERER]: [3, 6, 12, 24],
  [TROPHY_TYPE.CONSTRUCTIVE_REVIEWER]: [1, 2, 3, 4],
  // LEARNING_TROPHY
  [TROPHY_TYPE.MATH_MASTER]: [1, 3, 4, 5],
  [TROPHY_TYPE.POLISH_MASTER]: [1, 2, 3, 4],
  [TROPHY_TYPE.ENGLISH_MASTER]: [1, 3, 4, 6],
  [TROPHY_TYPE.MATH_QUIZ_MARATHONER]: [10, 20, 25, 30],
  [TROPHY_TYPE.POLISH_QUIZ_MARATHONER]: [10, 20, 25, 30],
  [TROPHY_TYPE.ENGLISH_QUIZ_MARATHONER]: [10, 20, 25, 30],
  [TROPHY_TYPE.MATH_PRECISE_MIND]: [10, 20, 25, 30],
  [TROPHY_TYPE.POLISH_PRECISE_MIND]: [10, 20, 25, 30],
  [TROPHY_TYPE.ENGLISH_PRECISE_MIND]: [10, 20, 25, 30],
  [TROPHY_TYPE.MATH_FLAWLESS_MIND]: [5, 10, 20, 30],
  [TROPHY_TYPE.POLISH_FLAWLESS_MIND]: [5, 10, 20, 30],
  [TROPHY_TYPE.ENGLISH_FLAWLESS_MIND]: [5, 10, 20, 30],
  [TROPHY_TYPE.MATH_VIDEO_ENTHUSIAST]: [5, 10, 20, 30],
  [TROPHY_TYPE.POLISH_VIDEO_ENTHUSIAST]: [5, 10, 20, 30],
  [TROPHY_TYPE.ENGLISH_VIDEO_ENTHUSIAST]: [5, 10, 20, 30],
  [TROPHY_TYPE.MATH_DIDACTIC_COLLECTOR]: [10, 20, 25, 30],
  [TROPHY_TYPE.POLISH_DIDACTIC_COLLECTOR]: [10, 20, 25, 30],
  [TROPHY_TYPE.ENGLISH_DIDACTIC_COLLECTOR]: [10, 20, 25, 30],
  // BIDIRECTIONAL_TROPHY
  [TROPHY_TYPE.TWO_SUBJECT_MASTER_MAT_ENG]: [1, 2, 4, 6],
  [TROPHY_TYPE.TWO_SUBJECT_MASTER_MAT_POL]: [1, 2, 4, 6],
  [TROPHY_TYPE.TWO_SUBJECT_MASTER_ENG_POL]: [1, 2, 4, 6],
  [TROPHY_TYPE.TWO_SECTION_EXPERT_MAT_ENG]: [1, 2, 3],
  [TROPHY_TYPE.TWO_SECTION_EXPERT_MAT_POL]: [1, 2, 3],
  [TROPHY_TYPE.TWO_SECTION_EXPERT_ENG_POL]: [1, 2, 3],
  [TROPHY_TYPE.QUIZ_DUO_MAT_ENG]: [5, 10, 15, 20],
  [TROPHY_TYPE.QUIZ_DUO_MAT_POL]: [5, 10, 15, 20],
  [TROPHY_TYPE.QUIZ_DUO_ENG_POL]: [5, 10, 15, 20],
  [TROPHY_TYPE.FLAWLESS_DUO_MAT_ENG]: [2, 5, 10, 20],
  [TROPHY_TYPE.FLAWLESS_DUO_MAT_POL]: [2, 5, 10, 20],
  [TROPHY_TYPE.FLAWLESS_DUO_ENG_POL]: [2, 5, 10, 20],
  [TROPHY_TYPE.VIDEO_DUO_MAT_ENG]: [2, 5, 10, 20],
  [TROPHY_TYPE.VIDEO_DUO_MAT_POL]: [2, 5, 10, 20],
  [TROPHY_TYPE.VIDEO_DUO_ENG_POL]: [2, 5, 10, 20],
  [TROPHY_TYPE.DIDACTIC_DUO_MAT_ENG]: [5, 10, 20, 25],
  [TROPHY_TYPE.DIDACTIC_DUO_MAT_POL]: [5, 10, 20, 25],
  [TROPHY_TYPE.DIDACTIC_DUO_ENG_POL]: [5, 10, 20, 25],
  // INTERDISCIPLINARY_TROPHY
  [TROPHY_TYPE.THREE_SUBJECT_MASTER]: [1, 2, 4, 6],
  [TROPHY_TYPE.THREE_SECTION_EXPERT]: [1, 2, 3],
  [TROPHY_TYPE.QUIZ_TRIATHLON]: [5, 10, 15, 20],
  [TROPHY_TYPE.FLAWLESS_TRIO]: [1, 2, 4, 6],
  [TROPHY_TYPE.VIDEO_TRIAD]: [1, 2, 4, 6],
  [TROPHY_TYPE.DIDACTIC_TRIAD]: [1, 2, 3, 4]
};

// src/consts/question.const.ts
var QUESTION_TYPE = {
  SINGLE_CHOICE: "single_choice",
  FREE_CHOICE: "free_choice",
  MULTIPLE_CHOICE: "multiple_choice",
  TRUE_OR_FALSE: "true_or_false",
  FILL_IN_THE_BLANKS_TEXT: "fill_in_the_blanks_text",
  FILL_IN_THE_BLANKS_DND: "fill_in_the_blanks_dnd",
  SCALE_1_5: "scale_1_5",
  SORTING: "sorting"
};
var QUESTION_TITLE_MAX_LENGTH = 500;
var QUESTION_DESCRIPTION_MAX_LENGTH = 1e4;
var QUESTION_ANSWER_OPTION_TEXT_MAX_LENGTH = 200;

// src/consts/register.const.ts
var PASSWORD_REGEX = /^.*(?=.*\p{L})(?=.*\d)(?=.*[^A-Za-z\d]).{8,}$/u;

// src/consts/resourceType.const.ts
var RESOURCE_TYPE = {
  LESSON: "lesson",
  LESSON_ITEM: "lessonItem",
  FILE: "file",
  COURSE: "course",
  USER: "user",
  SUBJECT: "subject",
  TEACHER: "teacher",
  FLASHCARD: "flashcard",
  VIMEO_THUMBNAIL: "vimeo-thumbnail"
};

// src/consts/subjects.const.ts
var SUBJECT_CODES = {
  MATH: "MATH",
  POLISH: "POLISH",
  ENGLISH: "ENGLISH"
};
var BASE_SUBJECTS = [SUBJECT_CODES.POLISH, SUBJECT_CODES.MATH, SUBJECT_CODES.ENGLISH];

// src/consts/subscription.const.ts
var SUBSCRIPTION_DURATION_DAYS = 90;

// src/consts/transactionStatus.ts
var TRANSACTION_STATUSES = {
  PENDING: "pending",
  SUCCESS: "success",
  FAILED: "failed"
};

// src/consts/userAuthentication.const.ts
var userAuthenticationTypes = ["EMAIL", "GOOGLE", "FACEBOOK", "TIKTOK"];
var USER_AUTHENTICATION_TYPES = {
  EMAIL: "EMAIL",
  GOOGLE: "GOOGLE",
  FACEBOOK: "FACEBOOK",
  TIKTOK: "TIKTOK"
};

// src/consts/userGroup.const.ts
var USER_GROUPS = {
  STAFF: "STAFF",
  USERS: "USERS"
};

// src/consts/userRole.const.ts
var USER_ROLES = {
  ADMIN: "ADMIN",
  STUDENT: "STUDENT",
  CONTENT_CREATOR: "CONTENT_CREATOR",
  GUARDIAN: "GUARDIAN"
};

// src/consts/websocketEvents.const.ts
var WS_EVENTS = {
  NOTIFICATION: "notification",
  SYSTEM_NOTIFICATION: "system_notification",
  PAYMENT_STATUS_SUCCESS: "payment_status_success",
  REQUEST_SUBSCRIPTION_STATUS: "request_subscription_status",
  VIDEO_PROGRESS_UPDATE: "video_progress_update",
  NEW_SYSTEM_MESSAGE: "new_system_message",
  ACHIEVEMENT_AWARDED: "achievement_awarded"
};

// src/utility/nullable.ts
import { Type } from "@sinclair/typebox";
var Nullable = (schema) => Type.Union([schema, Type.Null()]);
var NullableFields = (schema) => {
  if (schema.type !== "object") {
    throw new Error("NullableFields can only be applied to objects");
  }
  const properties = schema.properties ?? {};
  const nullableProperties = {};
  const required = Array.isArray(schema.required) ? [...schema.required] : [];
  for (const key in properties) {
    nullableProperties[key] = Nullable(properties[key]);
  }
  return Type.Object(nullableProperties, {
    additionalProperties: schema.additionalProperties,
    required
  });
};
export {
  ACTIVATION_STATUS_TYPES,
  AGGREGATE_TYPE,
  BADGE_TYPE,
  BASE_SUBJECTS,
  CHAT_BOT_ROLES,
  CONTENT_TYPES,
  CustomErrorCode,
  DEFAULT_PAGE_SIZE,
  DELETE_CONTENT_TYPES,
  EMAIL_TEMPLATES,
  ENVIRONMENT,
  EVENT_TYPE,
  FLASHCARD_CATEGORY_TITLE_MAX_LENGTH,
  FRIENT_INVITATION_STATUS,
  LESSON_TITLE_MAX_LENGTH,
  LESSON_TYPES,
  NON_TEXT_LESSON_DESCRIPTION_MAX_LENGTH,
  Nullable,
  NullableFields,
  PASSWORD_REGEX,
  PUBLISH_CONTENT_TYPES,
  QUESTION_ANSWER_OPTION_TEXT_MAX_LENGTH,
  QUESTION_DESCRIPTION_MAX_LENGTH,
  QUESTION_TITLE_MAX_LENGTH,
  QUESTION_TYPE,
  RESOURCE_TYPE,
  SUBJECT_CODES,
  SUBSCRIPTION_DURATION_DAYS,
  TEXT_LESSON_DESCRIPTION_MAX_LENGTH,
  TRANSACTION_STATUSES,
  TROPHY_REQUIREMENTS,
  TROPHY_TYPE,
  USER_AUTHENTICATION_TYPES,
  USER_GROUPS,
  USER_ROLES,
  WS_EVENTS,
  userAuthenticationTypes
};
